import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AutoForecastLogApi } from 'api';

export const findAutoForecastLog = createAsyncThunk(
  'autoForecastLog/findAutoForecastLog',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await AutoForecastLogApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const autoForecastLogSlice = createSlice({
  name: 'autoForecastLog',
  initialState: {},
  reducers: {},
});

const { reducer: autoForecastLogReducer } = autoForecastLogSlice;

export default autoForecastLogReducer;
